import React, { useState } from 'react';
import Video from '../../videos/Background.mp4';
import { Button } from '../ButtonElement';
import { 
    HeroContainer, 
    HeroBg, 
    VideoBg, 
    HeroContent, 
    HeroH1, 
    HeroP, 
    HeroBtnWrapper, 
    ArrowForward, 
    ArrowRight,
    DownloadSection,
    DownloadText,
    StoreButtonsWrapper,
    StoreButton,
    StoreImg,
    HeroContentWrapper,
    HeroVideoWrapper,
    GradientText
} from './HeroElements';
import AppStore from '../../images/downloadonappstore.png';
import PlayStore from '../../images/google-play-badge.png';

const HeroSection = () => {
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    }

    return (
        <HeroContainer>
            <HeroContentWrapper>
                <HeroContent>
                    <HeroH1>Oral Healthcare Redefined.</HeroH1>
                    <HeroP>
                        The only app that scientifically chooses the <GradientText>right-sized pacifier</GradientText> for your baby.
                    </HeroP>
                    <HeroBtnWrapper>
                        <Button 
                            to="about" 
                            onMouseEnter={onHover} 
                            onMouseLeave={onHover}
                            primary="true"
                            dark="true"
                            smooth={true} 
                            duration={500} 
                            spy={true} 
                            exact='true' 
                            offset={-80}
                        >
                            Learn More {hover ? <ArrowForward /> : <ArrowRight />}
                        </Button>
                    </HeroBtnWrapper>
                    <DownloadSection>
                        <DownloadText>Download Pacified App</DownloadText>
                        <StoreButtonsWrapper>
                            <StoreButton href="https://apps.apple.com/us/app/pacified/id1528971525" target="_blank" rel="noopener noreferrer">
                                <StoreImg src={AppStore} alt="Download on the App Store" />
                            </StoreButton>
                            <StoreButton href="https://play.google.com/store/apps/details?id=info.toothprints.pacified" target="_blank" rel="noopener noreferrer">
                                <StoreImg src={PlayStore} alt="Get it on Google Play" />
                            </StoreButton>
                        </StoreButtonsWrapper>
                    </DownloadSection>
                </HeroContent>
            </HeroContentWrapper>
            <HeroVideoWrapper>
                <HeroBg>
                    <VideoBg autoPlay loop muted playsInline src={Video} type='video/mp4' />
                </HeroBg>
            </HeroVideoWrapper>
        </HeroContainer>
    )
}

export default HeroSection;


